export const AUTH_LOCAL_STORAGE_KEY: string = "connectel-auth";
export const CART_KEY = "CART_ITEMS";
export const COUNTRY_KEY = "SELECTED_COUNTRY";
export const ORG_NR_KEY = "ORG_NR";
export const SYNC_REQUEST_PAGINATION_SIZE = 20;
